import { AppText } from '../../../../../../../../../../../../ui/text/AppText';
import React from 'react';
import { useLocalization } from '../../../../../../../../../../../../lib/hooks/useLocalization';
import { AppCheckbox } from '../../../../../../../../../../../../ui/AppCheckbox';

const appCheckBoxStyle = { marginBottom: 10 };

export function ProductBasedFinderButton({ item, isViewMode, onChange }) {
  const { productBasedFinderButton } = useLocalization().translations.unique.pages.result;

  const {
    content: { productBasedFinder },
  } = item;

  const handleChange = (event, fieldName) => {
    onChange({ ...productBasedFinder, [fieldName]: event.target.checked });
  };
  return (
    <div className='template_card_content_block'>
      <AppText className='template_card_headline' textValue={productBasedFinderButton.title} />
      <AppCheckbox
        style={appCheckBoxStyle}
        onChange={event => handleChange(event, 'showResultButton')}
        checked={productBasedFinder?.showResultButton}
        textValue={productBasedFinderButton.text}
        disabled={isViewMode}
      />
    </div>
  );
}
